import React, { useEffect, useState } from "react";
import { Button, Col, Pagination, Row, Table } from "antd";
import type { ColumnsType } from "antd/es/table";
import { useAppSelector } from "../..";
import { priceValidationCodes } from "../../lib/const";
import { SpanLimitText } from "../common/SpanLimitText";
import TablePageSelect from "../TablePageSelect/TablePageSelect";
import "./UploadPrice.less";

interface UploadPriceErrorProps {
  handleDeletePriceImport: () => void;
  codesTextLimit: number;
}

interface Data {
  key: number;
  rowNumber?: string;
  destination?: string;
  dialCodes?: string;
  rate?: string;
  effectiveDate?: string;
}

const uploadErrorCodes = [
  priceValidationCodes.invalidFormatError,
  priceValidationCodes.emptyFileldError,
];

/* ---------------------------------------------- Начало компонента ---------------------------------------------- */

export const UploadPriceError = (props: UploadPriceErrorProps) => {
  const { handleDeletePriceImport, codesTextLimit } = props;
  const [data, setData] = useState<Data[]>([]);
  const [pageSize, setPageSize] = useState<number>(10);
  const [pageNumber, setPageNumber] = useState<number>(1);

  const { priceValidationResult } = useAppSelector((state) => state.individualTariffs);

  // Заполнение данных для отображения
  useEffect(() => {
    setData(
      priceValidationResult
        // @ts-ignore
        .filter(({ message }) => message.some(({ code }) => uploadErrorCodes.includes(code)))
        .map(({ id, source }) => ({
          key: id,
          rowNumber: source?.rowNumber,
          destination: source?.Destination,
          dialCodes: source?.["Dial Codes"],
          rate: source?.Rate,
          effectiveDate: source?.["Effective Date"],
        }))
    );
  }, [priceValidationResult]);

  const columns: ColumnsType<Data> = [
    {
      title: "Номер строки",
      key: "rowNumber",
      dataIndex: "rowNumber",
    },
    {
      title: "Направление",
      key: "destination",
      dataIndex: "destination",
    },
    {
      title: "Коды",
      key: "dialCodes",
      dataIndex: "dialCodes",
      render: (dialCodes) => <SpanLimitText text={dialCodes} limit={codesTextLimit} />,
    },
    {
      title: "Цена",
      key: "rate",
      dataIndex: "rate",
    },
    {
      title: "Дата",
      key: "effectiveDate",
      dataIndex: "effectiveDate",
    },
  ];

  return (
    <div className="upload-price">
      <Row justify="space-between">
        <Col />
        <Col offset={5}>
          <Pagination
            onChange={setPageNumber}
            current={pageNumber}
            total={data.length}
            pageSize={pageSize}
            hideOnSinglePage
            size="small"
            showSizeChanger={false}
            style={{ marginTop: "4px" }}
          />
        </Col>
        <Col>
          <TablePageSelect
            onChange={setPageSize}
            value={pageSize}
            pageSizeOptions={{ 10: 10, 20: 20, 50: 50, 100: 100 }}
          />
        </Col>
      </Row>
      <span style={{ color: "red" }}>Файл не соответствует шаблону</span>
      <Table
        size="small"
        dataSource={data}
        columns={columns}
        pagination={{
          total: data.length,
          pageSize,
          current: pageNumber,
          style: { display: "none" },
        }}
      />
      <Row gutter={20} justify="center" style={{ margin: "20px" }}>
        <Col>
          <Button onClick={handleDeletePriceImport} className="xl-btn">
            Отменить импорт
          </Button>
        </Col>
      </Row>
    </div>
  );
};
